import { render } from "./TwoFactorChallenge.vue?vue&type=template&id=2dc8b747"
import script from "./TwoFactorChallenge.vue?vue&type=script&lang=js"
export * from "./TwoFactorChallenge.vue?vue&type=script&lang=js"
script.render = render

export default script